export enum Region {
    Africa = 1,
    Asia = 2,
    Caribbean = 3,
    Europe = 4,
    LatinAmerica = 5,
    MiddleEast = 6,
    NorthAmerica= 7,
    PacificRim= 8
}
